import classNames from 'classnames';
import React from 'react';
import css from '../../styles.module.scss';

type Props = {
  position: number;
  dataTestId?: string;
  showIconComponent: boolean;
};

export const ScreenNumber: React.FC<Props> = ({ position, showIconComponent, dataTestId = 'screenNumber' }) => {
  if (showIconComponent) {
    return null;
  }

  return (
    <div className={classNames(css.screenNumber)} data-testid={dataTestId}>{position}</div>
  );
};

